import { RetrievalMode, RetrievalStatus } from '@prisma/client';

// The valid retrieval-status transitions, by mode and current status.
export const ALLOWED_RETRIEVAL_STATUS_CHANGES: Record<
  RetrievalMode,
  Partial<Record<RetrievalStatus, RetrievalStatus[]>>
> = {
  [RetrievalMode.MAIL]: {
    [RetrievalStatus.AWAITING_BOOKING]: [RetrievalStatus.BOOKED],
    [RetrievalStatus.BOOKED]: [
      RetrievalStatus.AWAITING_BOOKING,
      RetrievalStatus.DISPATCHED,
    ],
    [RetrievalStatus.DISPATCHED]: [RetrievalStatus.RETURNED_READY_FOR_PICKUP],
    [RetrievalStatus.RETURNED_READY_FOR_PICKUP]: [RetrievalStatus.PICKED_UP],
  },
  [RetrievalMode.PICKUP]: {
    [RetrievalStatus.READY_FOR_PICKUP]: [RetrievalStatus.PICKED_UP],
  },
  [RetrievalMode.NONE]: {},
};

export const canTransitionRetrievalStatus = (
  from: RetrievalStatus,
  to: RetrievalStatus,
  retrievalMode: RetrievalMode,
): boolean =>
  (ALLOWED_RETRIEVAL_STATUS_CHANGES[retrievalMode][from] ?? []).includes(to);

// AWAITING_BOOKING/BOOKED are set by the booking/cancel webhook (which also writes appointmentId),
// never by the staff status endpoint.
export const WEBHOOK_MANAGED_STATUSES: RetrievalStatus[] = [
  RetrievalStatus.AWAITING_BOOKING,
  RetrievalStatus.BOOKED,
];

// A MAIL retrieval can only be switched to PICKUP while it is in one of these two statuses.
export const PRE_DISPATCH_RETRIEVAL_STATUSES: RetrievalStatus[] = [
  RetrievalStatus.AWAITING_BOOKING,
  RetrievalStatus.BOOKED,
];

/** No sample is pending: it was posted, collected, came back, or there is none (voucher). */
export const SETTLED_RETRIEVAL_STATUSES: RetrievalStatus[] = [
  RetrievalStatus.DISPATCHED,
  RetrievalStatus.RETURNED_READY_FOR_PICKUP,
  RetrievalStatus.PICKED_UP,
  RetrievalStatus.NO_FULFILLMENT,
];
